/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

	'use strict';
	
	(function () {
	
		function drawArc() {
			$('canvas').each(function () {
				var windowWidth = $(window).innerWidth();
				var halfWidth = windowWidth / 2;
				var roundwidth = Math.round(windowWidth);
				var height = windowWidth * 0.039375;
				var roundHeight = Math.round(height);
				var rh = Math.round(height);
				var canvas = document.getElementById('idx-onair_canvas');
	
				if (!canvas || !canvas.getContext) {
					return false;
				}
	
				$('canvas').each(function () {
					this.setAttribute('width', windowWidth);
					this.setAttribute('height', roundHeight);
					$(this).css('top', '-' + roundHeight + 'px');
				});
	
				var ctx = canvas.getContext('2d');
	
				ctx.moveTo(0, roundHeight);
				ctx.lineTo(0, 0);
				ctx.quadraticCurveTo(halfWidth, roundHeight * 2, windowWidth, 0);
				ctx.lineTo(windowWidth, roundHeight);
				ctx.closePath();
				ctx.fillStyle = '#fafafa';
				ctx.fill();
			});
		}
	
		window.addEventListener('load', function () {
			drawArc();
		});
		window.addEventListener('resize', function () {
			drawArc();
		});
	
		var MenuTarget = document.getElementById('st-header_nav');
		var MenuOpenFlag = false;
		var MenuOpenButton = document.getElementById('st-header-open');
		var MenuCloseButton = document.getElementById('st-header-close');
		MenuOpenButton.addEventListener('click', function () {
			if (!MenuOpenFlag) {
				MenuOpenFlag = true;
				MenuTarget.className = 'st-header_nav st-header_nav-visible';
			}
		});
		MenuCloseButton.addEventListener('click', function () {
			if (MenuOpenFlag) {
				MenuOpenFlag = false;
				MenuTarget.className = 'st-header_nav';
			}
		});
	
		var topButton = document.getElementById('st-page-top');
		window.onscroll = function () {
			if (window.pageYOffset > 100) {
				topButton.className = 'st-page-top st-page-top-visible';
			} else {
				topButton.className = 'st-page-top st-page-top-hidden';
			}
		};
	
		$("a[href^=#]").on("click", function () {
			var linkSpeed = 800;
			var linkHref = $(this).attr("href");
	
			if (linkHref == "#houhouLinkDouga" || linkHref == "#houhouLinkLive" || linkHref == "#houhouLinkSeiga") {
				var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
				var linkPosition = linkTarget.offset().top - 50;
				$("html, body").animate({ scrollTop: linkPosition }, linkSpeed, "swing");
			} else {
				var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
				var linkPosition = linkTarget.offset().top;
				$("html, body").animate({ scrollTop: linkPosition }, linkSpeed, "swing");
			}
	
			return false;
		});
	})();

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// common.bundle.js